import { Modal } from '@sailadv/hdata-ui';
import styled from 'styled-components';

import { Box } from '@/shared/ui/box';
import { Icon as UIIcon } from '@/shared/ui/icon';
import { Text } from '@/shared/ui/text';

export const Wrapper = styled(Box)`
	background-color: ${({ theme: { modal } }) => modal.background};
	border: 1px solid ${({ theme: { modal } }) => modal.border};
	border-radius: ${({ theme: { modal } }) => modal.radius};

	@media ${({ theme: { media } }) => media.mobile} {
		width: 100%;
		position: fixed;
		right: 0;
		top: 0;
		left: 0;
		bottom: 0;
		z-index: ${({ theme: { zIndex } }) => zIndex.modal};
		justify-content: space-between;
	}
`;

export const Content = styled(Box)`
	height: 160px;

	@media ${({ theme: { media } }) => media.mobile} {
		height: auto;
	}
`;

export const Icon = styled(UIIcon)<{ disabled?: boolean }>`
	cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
	fill: ${({ theme: { modal } }) => modal.icon};
	transition: ${({ theme: { transition } }) => transition.primary};
	opacity: 1;
	pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

	&:hover {
		opacity: ${({ disabled }) => (disabled ? 1 : 0.7)};
	}
`;

export const Description = styled(Text)`
	word-break: break-word;

	@media ${({ theme: { media } }) => media.mobile} {
		width: auto;
	}
`;

export const Footer = styled(Box)`
	background-color: ${({ theme: { modal } }) => modal.backgroundActions};
	border-top: 1px solid ${({ theme: { modal } }) => modal.border};
	border-bottom-left-radius: ${({ theme: { modal } }) => modal.radius};
	border-bottom-right-radius: ${({ theme: { modal } }) => modal.radius};
`;

// TODO: Remove this temporary workaround once hdata-ui Modal supports dropdowns extending beyond the dialog.
export const OverflowVisibleModal = styled(Modal)`
	overflow: visible;
`;
